import React, { FC, useState, useEffect } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Grid,
  InputLabel,
  Tooltip,
} from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormRadioButtonField: React.FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState<string>(props.value || "");

  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setValue(props.value);
    }
  }, [props.value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    if (props.onChange) {
      props.onChange({
        target: {
          id: event.target.name,
          value: event.target.value,
        },
      });
    }
  };

  const isOptionObject = (
    option: any
  ): option is { label: string; value: string | boolean } => {
    return typeof option === "object" && "label" in option && "value" in option;
  };

  const radioButtonRender = () => (
    <FormControl
      ref={props.inputRef} // ✅ Scroll target
      style={{ marginTop: props?.isNonMarginTop ? "0px" : "" }}
      fullWidth
      sx={{
        mt: 1,
        mb: 1,
        "& .MuiOutlinedInput-root": {
          border: "1px solid #c4c4c4",
        },
      }}
      error={Boolean(props.error)}
      size="small"
    >
      <RadioGroup
        row={props.row || false}
        name={props.id}
        value={value} // Controlled value
        onChange={handleChange}
      >
        {props.radioOptions &&
          props.radioOptions.map((option, index) => (
            <FormControlLabel
              key={index}
              labelPlacement={
                ["end", "start", "top", "bottom"].includes(props.labelPlacement as string)
                  ? (props.labelPlacement as "end" | "start" | "top" | "bottom")
                  : "top"
              }
              value={isOptionObject(option) ? option.value : option}
              control={
                <Radio
                  disabled={props.disabled}
                  color="primary"
                  sx={{
                    color: props?.error ? "red" : "",
                    // border: props?.error ? "1px solid red" : "1px solid #c4c4c4",
                    // borderRadius: "4px",
                    // padding: "5px",
                    "& .MuiSvgIcon-root": {
                      fontSize: "16px", // Set radio button size
                    },
                  }}
                />
              }
              label={isOptionObject(option) ? option.label : option}
              sx={{
                marginRight: "20px",
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px", // Set label font size
                },
              }}
            />
          ))}
      </RadioGroup>
    </FormControl>
  );

  return (
    <>
      {props.label && !props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? 1.5 : 5}
            className={classes.labelBox}
            sx={{ marginTop: props?.isNonMarginTop ? "0px !important" : "" }}
          >
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props.id}
            >
              {props.label}
              {props.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{ padding: "0px" }}
          >
            {radioButtonRender()}
          </Grid>
        </>
      ) : props?.label && props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 12}
            sx={{
              display: "block",
              alignItems: "center",
              gap: 2,
              ...props?.GridFieldStyle,
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{
                  color: "#637381",
                  fontWeight: 600,
                  fontSize: "16px",
                  textAlign: "left !important",
                  paddingLeft: "8px",
                }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
            {radioButtonRender()}
          </Grid>
        </>
      ) : (
        <Grid
          item
          xs={12}
          sm={props?.md ? props?.md : 7}
          style={{ padding: "0px" }}
        >
          <>{radioButtonRender()}</>
        </Grid>
      )}
    </>
  );
};

export default FormRadioButtonField;
